/* JANUS — VHS effects layer. Settings arrive as data attributes on <body> (see layout/theme.liquid).
   Nothing here is needed for the shop to work: if this file fails or is switched off, every image,
   heading and link behaves normally. */
(function () {
  var body = document.body;
  var cfg = body.dataset;
  if (cfg.vhs !== 'true') return;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = !!(window.Shopify && window.Shopify.designMode);
  var store = function (fn) { try { return fn(window.sessionStorage); } catch (e) { return null; } };

  body.classList.add('vhs-on');
  var header = document.querySelector('.site-header');
  var setHeader = function () { if (header) document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px'); };
  setHeader(); window.addEventListener('resize', setHeader);
  var osdText = function (cls, html, life) {
    var el = document.createElement('div'); el.className = cls; el.setAttribute('aria-hidden', 'true'); el.innerHTML = html;
    body.appendChild(el); setTimeout(function () { el.remove(); }, life); return el;
  };
  if (cfg.vhsIntensity === 'subtle') {
    document.documentElement.style.setProperty('--vhs-speed', '1.35');
    document.documentElement.style.setProperty('--vhs-scan', '.18');
  }

  /* ---------- screen texture ---------- */
  if (cfg.vhsScreen === 'true') {
    var screen = document.createElement('div');
    screen.className = 'vhs-screen';
    screen.setAttribute('aria-hidden', 'true');
    body.appendChild(screen);
  }

  /* ---------- tape counter: scroll position is the tape position ---------- */
  if (cfg.vhsOsd === 'true') {
    var osd = document.createElement('div');
    osd.className = 'vhs-osd';
    osd.setAttribute('aria-hidden', 'true');
    osd.innerHTML = '<span class="vhs-osd__state" data-state="play">PLAY &#9654;</span><span class="vhs-osd__time">0:00:00</span><span class="vhs-osd__mode">SP</span>';
    body.appendChild(osd);
    var stateEl = osd.querySelector('.vhs-osd__state');
    var timeEl = osd.querySelector('.vhs-osd__time');
    var labels = { play: 'PLAY &#9654;', ff: 'FF &#9654;&#9654;', rew: 'REW &#9664;&#9664;', pause: 'PAUSE &#10074;&#10074;' };
    var lastY = window.scrollY, idle = null, ticking = false, state = '';
    var setState = function (s) { if (s === state) return; state = s; stateEl.dataset.state = s; stateEl.innerHTML = labels[s]; };
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var paint = function () {
      ticking = false;
      var y = window.scrollY;
      var secs = Math.round(y / 6);                       // ~6px of scroll = one second of tape
      timeEl.textContent = Math.floor(secs / 3600) + ':' + pad(Math.floor(secs / 60) % 60) + ':' + pad(secs % 60);
      var dy = y - lastY; lastY = y;
      if (Math.abs(dy) > 2) setState(dy > 0 ? 'ff' : 'rew');
      clearTimeout(idle);
      idle = setTimeout(function () { setState('play'); idle = setTimeout(function () { setState('pause'); }, 6000); }, 220);
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(paint); } }, { passive: true });
    setState('play'); paint();
    // keep it out of the way while the menu or basket is open
    new MutationObserver(function () { osd.classList.toggle('is-hidden', !!document.querySelector('.is-open[data-panel]')); })
      .observe(body, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- basket: REC when something goes in ---------- */
  var countEl = document.querySelector('[data-cart-count]');
  if (countEl) {
    var lastCount = parseInt(countEl.getAttribute('data-count') || countEl.textContent, 10) || 0;
    new MutationObserver(function () {
      var n = parseInt(countEl.getAttribute('data-count') || countEl.textContent, 10) || 0;
      if (n > lastCount) osdText('vhs-toast', '<i>&#9679;</i><span>REC</span><span>ADDED TO BASKET</span>', 2000);
      lastCount = n;
    }).observe(countEl, { attributes: true, childList: true, characterData: true, subtree: true });
  }

  if (reduced) return; // everything below moves

  /* ---------- basket + menu panels: track in on open, CRT collapse on close ---------- */
  document.querySelectorAll('[data-panel]').forEach(function (panel) {
    var wasOpen = panel.classList.contains('is-open');
    new MutationObserver(function () {
      var open = panel.classList.contains('is-open');
      if (open === wasOpen) return;
      wasOpen = open;
      panel.classList.remove('vhs-panel-in', 'vhs-panel-out');
      void panel.offsetWidth; // restart the animation
      panel.classList.add(open ? 'vhs-panel-in' : 'vhs-panel-out');
      clearTimeout(panel._vhsT);
      panel._vhsT = setTimeout(function () { panel.classList.remove('vhs-panel-in', 'vhs-panel-out'); }, 700);
      if (open && panel.matches('[data-cart-drawer]')) osdText('vhs-flash vhs-flash--panel', '&#9167; EJECT', 900);
    }).observe(panel, { attributes: true, attributeFilter: ['class'] });
  });

  /* ---------- images track in, headings type on, as they scroll into view ---------- */
  var reveal = cfg.vhsReveal === 'true' && !editor && 'IntersectionObserver' in window;
  var io = reveal && new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var el = en.target; io.unobserve(el);
      afterBoot(function () { play(el); });
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });

  // anything that comes into view while the intro is still up waits for it to finish
  function afterBoot(fn) { if (document.querySelector('.vhs-boot')) setTimeout(function () { afterBoot(fn); }, 80); else fn(); }
  function play(el) {
      if (el.classList.contains('vhs-type-armed')) {
        el.classList.remove('vhs-type-armed'); el.classList.add('vhs-type-in');
        setTimeout(function () { el.classList.remove('vhs-type-in'); }, 1300);
        return;
      }
      var fx = document.createElement('span'); fx.className = 'vhs-fx'; fx.setAttribute('aria-hidden', 'true');
      el.appendChild(fx);
      el.classList.remove('vhs-armed'); el.classList.add('vhs-in');
      setTimeout(function () { fx.remove(); el.classList.remove('vhs-in'); }, cfg.vhsIntensity === 'subtle' ? 1100 : 1400);
  }

  var arm = function (scope) {
    if (!io) return;
    var vh = window.innerHeight;
    scope.querySelectorAll('.media, .hero__media, [data-vhs-reveal]').forEach(function (el) {
      if (el.dataset.vhsDone || !el.querySelector('img')) return;
      el.dataset.vhsDone = '1';
      if (el.getBoundingClientRect().top < vh * 0.85 && !el.closest('.hero')) { return; } // already on screen at load: leave it alone
      el.classList.add('vhs-armed'); io.observe(el);
    });
    scope.querySelectorAll('.section-head h2, .hero h1, [data-vhs-type]').forEach(function (el) {
      if (el.dataset.vhsDone) return;
      el.dataset.vhsDone = '1';
      // the text moves into an inner wrapper so the heading itself stays observable while the words are hidden
      var inner = document.createElement('span'); inner.className = 'vhs-type-inner';
      while (el.firstChild) inner.appendChild(el.firstChild);
      el.appendChild(inner);
      el.classList.add('vhs-type-armed'); io.observe(el);
    });
  };
  arm(document);
  document.addEventListener('shopify:section:load', function (e) { arm(e.target); });

  /* ---------- power-on: once per visit ---------- */
  var booted = false;
  if (cfg.vhsBoot === 'true' && !editor && !store(function (s) { return s.getItem('janus-vhs-booted'); })) {
    booted = true;
    store(function (s) { s.setItem('janus-vhs-booted', '1'); });
    var boot = document.createElement('div');
    boot.className = 'vhs-boot';
    boot.setAttribute('aria-hidden', 'true');
    var now = new Date();
    var stamp = now.toLocaleDateString('en-GB', { month: 'short', day: '2-digit', year: 'numeric' }).toUpperCase() + ' ' + now.toTimeString().slice(0, 5);
    boot.innerHTML = '<div class="vhs-boot__row"><span class="vhs-boot__play">PLAY &#9654;</span><span>CH 03</span></div>' +
                     '<div class="vhs-boot__row"><span>SP 0:00:00</span><span>' + stamp + '</span></div>';
    var end = function () { boot.remove(); };
    boot.addEventListener('animationend', function (e) { if (e.animationName === 'vhs-boot-out') end(); });
    boot.addEventListener('click', function () { boot.classList.add('is-skipped'); });
    document.addEventListener('keydown', function skip() { boot.classList.add('is-skipped'); document.removeEventListener('keydown', skip); });
    setTimeout(end, 3000); // never let it block the page
    body.appendChild(boot);
  }

  /* ---------- leaving: a burst of static on internal links ---------- */
  if (cfg.vhsTransitions === 'true' && !editor) {
    var staticEl = document.createElement('div');
    staticEl.className = 'vhs-static';
    staticEl.setAttribute('aria-hidden', 'true');
    body.appendChild(staticEl);
    window.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest('a[href]');
      if (!a || a.target && a.target !== '_self' || a.hasAttribute('download')) return;
      var url;
      try { url = new URL(a.href, location.href); } catch (err) { return; }
      if (url.origin !== location.origin || (url.pathname === location.pathname && url.hash)) return;
      // Shopify's own flows (log in, account, checkout) redirect off-site: let them go straight through
      if (/^\/(account|customer_authentication|checkout|checkouts|challenge|password|tools|apps|services)(\/|$)/.test(url.pathname) || /^\/cart\/(add|change|clear|update)/.test(url.pathname) || a.hasAttribute('data-no-vhs')) return;
      e.preventDefault();
      var dest = (a.getAttribute('aria-label') || a.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase().slice(0, 28);
      if (!dest || /^[^A-Z0-9]*$/.test(dest)) dest = url.pathname === '/' ? 'HOME' : 'LOADING';
      var words = osdText('vhs-static__osd', '<span>&#9654;&#9654; FF</span><b></b>', 4000);
      words.querySelector('b').textContent = dest;
      store(function (s) { s.setItem('janus-vhs-arrive', '1'); });
      staticEl.classList.add('is-on');
      setTimeout(function () { location.href = url.href; }, 200);
      // if the next page is slow to answer, don't leave a screen full of static
      setTimeout(function () { staticEl.classList.remove('is-on'); words.remove(); }, 2500);
    });
    // coming back via the back button: clear the static
    window.addEventListener('pageshow', function () { staticEl.classList.remove('is-on'); document.querySelectorAll('.vhs-static__osd').forEach(function (el) { el.remove(); }); });
    // arriving from another JANUS page: the picture rolls into place and PLAY flashes up
    if (!booted && store(function (s) { var v = s.getItem('janus-vhs-arrive'); s.removeItem('janus-vhs-arrive'); return v; })) {
      body.classList.add('vhs-arrive');
      setTimeout(function () { body.classList.remove('vhs-arrive'); }, 500);
      osdText('vhs-flash', 'PLAY &#9654;', 1400);
    }
  }
})();
